import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { AUDIENCE_POINTS, DISCIPLINES } from './salesData';
import { AUDIENCE_IMAGE_URL } from '../utils/headMeta';
export function AudienceSection() {
  return <section id="para-quien" className="bg-ivory py-12 sm:py-16" data-id="element-38" data-mp="s1e2fqfkfma7">
      <div className="mx-auto max-w-5xl px-5" data-id="element-39" data-mp="wymnbys3m4f5">
        <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-40" data-mp="wxl7zi41uvrm">
          <div data-id="element-41" data-mp="3viwb2035wxbo">
            <h2 className="font-display text-[1.5rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.1rem]" data-id="element-42" data-mp="3vf8gqypw86vw">
              El Método Consultorio Rentable es{' '}
              <span className="text-gold-deep" data-id="element-43" data-mp="98ik3sito6oo">para vos si…</span>
            </h2>

            <ul className="mt-6 space-y-2.5" data-id="element-44" data-mp="e1v6dw0141e9">
              {AUDIENCE_POINTS.map((point, i) => <motion.li key={point} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-40px'
            }} transition={{
              duration: 0.3,
              delay: i * 0.04
            }} className="flex items-start gap-2.5" data-id="element-45" data-mp="3cpsfg96dwaef" data-mpi={i}>
                  <span className="mt-[2px] flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-46" data-mp="ukzknlgiuf0f">
                    <CheckIcon className="h-2.5 w-2.5 text-ivory" aria-hidden data-id="element-47" data-mp="qjxnda660d13" />
                  </span>
                  <span className="font-sans text-[0.86rem] leading-relaxed text-charcoal/75" data-id="element-48" data-mp="lkkzqn7gz1xg">
                    {point}
                  </span>
                </motion.li>)}
            </ul>

            <ul className="mt-6 flex flex-wrap gap-1.5" aria-label="Especialidades" data-id="element-49" data-mp="bn6joopgkf5o">
              {DISCIPLINES.map(d => <li key={d} className="rounded-full border border-stone bg-sand px-2.5 py-1 font-sans text-[0.68rem] font-medium text-charcoal/70" data-id="element-50" data-mp="7mcw5wfxh2db">
                  {d}
                </li>)}
            </ul>
          </div>

          <img src={AUDIENCE_IMAGE_URL} alt="Odontóloga revisando los números y la agenda de su consultorio en la recepción" width={1200} height={800} loading="lazy" decoding="async" sizes="(max-width: 1024px) 90vw, 480px" style={{
          aspectRatio: '3 / 2'
        }} className="h-auto w-full rounded-2xl border border-stone object-cover shadow-[0_28px_60px_-40px_rgba(10,26,51,0.5)]" data-id="element-51" data-mp="3vfqngyf7hjnl" />
        </div>
      </div>
    </section>;
}